import { hydrate } from 'react-dom';
import { ready } from '@media-platform/promisified-dom-events';
import tracerInit from 'Tools/tracer';
import getServerState from '../../tools/getPreloadedState';
import { getWorker } from '@media-ui/core/src/tools/swInstaller';
import DiafilmApp from './app';
import { AppPrefixes } from 'Src/constants';
import type { IDiafilmAppProps } from './app/index.types';
tracerInit();
void ready.then(async () => {
    void getWorker({
        workerKey: 'sw-common',
        workers: {
            'sw-common': `/sw-common.js`,
        },
    });
    const context = await getServerState<IDiafilmAppProps>(AppPrefixes.Diafilm);
    hydrate(<DiafilmApp {...context}/>, document.getElementById(`root-${AppPrefixes.Diafilm}`));
});
